/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter resolution and diagonal size to calculate PPI.`)
};

const es_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce la resolución y el tamaño diagonal para calcular el PPI.`)
};

const de_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib Auflösung und Diagonale ein, um den PPI-Wert zu berechnen.`)
};

const nl_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul resolutie en diagonale grootte in om de PPI te berekenen.`)
};

const fr_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez la résolution et la taille diagonale pour calculer le PPP.`)
};

const it_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci risoluzione e dimensione diagonale per calcolare il PPI.`)
};

const pt_br2_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe a resolução e o tamanho diagonal para calcular o PPI.`)
};

const pt_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza a resolução e o tamanho diagonal para calcular o PPI.`)
};

const ja_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPIを計算するには解像度と対角サイズを入力してください。`)
};

const zh_ppi_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入分辨率和对角线尺寸以计算 PPI。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_hint", locale)
	if (locale === "en") return en_ppi_hint(inputs)
	if (locale === "es") return es_ppi_hint(inputs)
	if (locale === "de") return de_ppi_hint(inputs)
	if (locale === "nl") return nl_ppi_hint(inputs)
	if (locale === "fr") return fr_ppi_hint(inputs)
	if (locale === "it") return it_ppi_hint(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_hint(inputs)
	if (locale === "pt") return pt_ppi_hint(inputs)
	if (locale === "ja") return ja_ppi_hint(inputs)
	return zh_ppi_hint(inputs)
};